import { PLAY_URL } from "@/lib/userGuide";

export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);

export const isPlayApp = () => {
  if (document.referrer.startsWith("android-app://")) sessionStorage.setItem("kash_twa", "1");
  return sessionStorage.getItem("kash_twa") === "1";
};

export default function PlayBadge({ testid = "play-badge", className = "h-12" }) {
  if (isIOS() || isPlayApp()) return null;
  return (
    <a data-testid={testid} href={PLAY_URL} target="_blank" rel="noopener noreferrer"
      className="inline-block hover:-translate-y-0.5 transition-transform duration-200" title="Get KashAssist on Google Play">
      <img src="/badges/google-play.png" alt="Get it on Google Play" width="564" height="168" className={`${className} w-auto`} />
    </a>
  );
}
